import { TagUtil } from '../../tags/utils/TagUtil';
import { FeedItemDTO } from '../dtos/FeedItem.dto';
import { FeaturedItemType } from '../infra/types';
import { FeaturedFeedItemModel } from '../models/FeaturedFeedItem.model';
export class FeaturedUtil {
  public static mapToViewModel(
    dto: FeedItemDTO<FeaturedItemType>,
  ): FeaturedFeedItemModel {
    return {
      id: dto.id,
      type: dto.feedItemType,
      headline: dto.headline,
      tagline: dto.tagline,
      coverImage: dto.coverImage,
      access: dto.access,
      status: dto.status,
      tags: dto.tags ? dto.tags.map((tag) => TagUtil.mapToViewModel(tag)) : [],
      citationRequired: dto.citationRequired,
      publishedOn: dto.publishedOn,
      feedType: dto.feedItemType,
    };
  }
}
